// extracted by mini-css-extract-plugin
export var deleteIcon = "_ix-5";
export var deleteOption = "_ix-3";
export var divider = "_ix-2";
export var downloadIcon = "_ix-4";
export var drawer = "_ix-0";
export var drawerFooter = "_ix-6";
export var drawerOpen = "_ix-1";
export var highlighted = "_ix-7";
export var lighterHighlight = "_ix-8";